import React, { PropTypes } from 'react'

const WIDTH = 350
const RATIO = 2.0
const HEIGHT = WIDTH * RATIO

const INNER_WIDTH = 280
const INNER_HEIGHT = 499

const getStyles = () => ({
  root: {
    background: "url('./images/phone.png') 0 0 no-repeat",
    backgroundSize: `${WIDTH}px ${HEIGHT}px`,
    width: WIDTH,
    height: HEIGHT,
    position: 'relative'
  },
  content: {
    position: 'absolute',
    top: 101, left: 33,
    width: INNER_WIDTH,
    height: INNER_HEIGHT,
  }
})

const Phone = ({ images, currentImage, auto, children, style, ...rest }) => {
  const styles = getStyles(rest)

  return (
    <div style={{ ...styles.root, ...style }}>
      <div style={styles.content}>
        { children }
      </div>
    </div>
  )
}

Phone.propTypes = {
  images: PropTypes.array,
  auto: PropTypes.bool,
  children: PropTypes.any
}

Phone.defaultProps = {
  images: [],
  auto: true
}

export default Phone



// WEBPACK FOOTER //
// ./src/components/Phone.js